<template>
  <doc-notification-item-template
    :actorFullName="actorFullName"
    :actionName="actionName"
    :docCode="docCode"
    :docDate="docDate"
    :quote="quote"
    :state="state"
    :checkIsDiscuss="checkIsDiscuss"
    :checkIsDocument="checkIsDocument"
    :checkIsHcNotification="checkIsHcNotification"
    :checkIsVbNotificationV2="checkIsVbNotificationV2"
    :checkIsVbNotificationV1="checkIsVbNotificationV1"
    :checkIsCVNotification="checkIsCVNotification"
    :checkIsCVQuaHan="checkIsCVQuaHan"
    :checkIsLetter="checkIsLetter"
    :remainingDay="remainingDay"
    @click="click"
  >
  </doc-notification-item-template>
</template>

<script>
import DocNotificationItemTemplate from "../common/layout/doc-notification-item-template";
import constants from "../../constants";
import errorMessageFilter from "../../filters/errorMessageFilter";

export default {
  name: "vb-notification-item",
  props: ["notificationDetail"],
  components: { DocNotificationItemTemplate },
  data() {
    return {
      actionName: null,
      quote: null,
      docCode: null,
      docDate: null,
      actorFullName: null,
      checkIsCVQuaHan: false,
      checkIsVbNotificationV1: false,
      checkIsVbNotificationV2: false,
      checkIsHcNotification: false,
      checkIsDiscuss: false,
      checkIsDocument: false,
      checkIsCVNotification: false,
      checkIsLetter: false,
      remainingDay: -1,
      state: null,
      LETTERS: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.YEU_CAU,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.PHE_DUYET,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.TU_CHOI,
      ],
      CV_MESSAGE_TYPES: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_GIAOVIEC,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_DANGKY,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TAMDUNG,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HUY,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CHANGE_DEADLINE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HOANTHANH,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CAPNHAT_TIENDO,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.TK_TASK.COMMENT,
      ],
      HC_MESSAGE_TYPES: {
        // Phòng họp
        PHONG_HOP: [
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.CAP_NHAT_PHONG_HOP,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.PHE_DUYET_PHONG_HOP,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.TU_CHOI_PHONG_HOP,
        ],
        // Điều xe
        DIEU_XE: [
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.HUY_YEU_CAU,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.PHE_DUYET,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI,
        ],
        // Lịch tuần
        LICH_TUAN: [
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.CAP_NHAT,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
            .HUY_YEU_CAU,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.PHE_DUYET,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.DANG_KY,
          constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.TU_CHOI,
        ],
      },

      VB_MESSAGE_TYPE_V1: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_TUCHOI,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_KETTHUC,
      ],
      DISCUSS_TYPE: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT,
      ],
      DOCUMENT_TYPE: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_APPROVE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_CREATE,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_REJECT,
      ],
      VB_MESSAGE_TYPE_V2: [
        "chuyenXuLy",
        "chuyenTiep",
        "thuHoi",
        "ketThuc",
        "tuChoi",
        "tuChoiBanHanh",
        "banhanh",
        "choBanHanh",
        "CC",
        "chuyenTiepLanhDao",
        constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH,
        constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN,
        constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI,
      ],
    };
  },

  watch: {
    notificationDetail() {
      this.initComponent();
    },
  },

  created() {
    this.initComponent();
  },

  methods: {
    click(event) {
      this.$emit("click", event);
    },

    initComponent() {
      let info = JSON.parse(this.notificationDetail.dataJson);
      this.actorFullName = this.notificationDetail.fromUserName;
      this.actionName = this.buildActionLabel(info);

      if (
        this.notificationDetail.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.TK_TASK.COMMENT &&
        info.vbComment &&
        info.vbComment.fromFullName
      ) {
        // actorFullName của comment
        this.actorFullName = info.vbComment.fromFullName;
      }

      this.quote = this.buildNameQuote(info);
      this.remainingDay = info.remainingDay || 0;
      this.state =
        this.remainingDay >= 0
          ? errorMessageFilter({
              errorCode: "canhBaoQuaHan.toiHan.label",
              params: [this.remainingDay],
            })
          : errorMessageFilter({
              errorCode: "canhBaoQuaHan.quaHan.label",
              params: [Math.abs(this.remainingDay)],
            });
      this.checkIsVbNotificationV1 = this.isVbNotificationV1();
      this.checkIsVbNotificationV2 = this.isVbNotificationV2();
      this.checkIsDiscuss = this.isDiscuss();
      this.checkIsDocument = this.isDocument();
      this.checkIsLetter = this.isLetter();
      this.checkIsCVNotification = this.isCVNotification();
      this.checkIsCVQuaHan = this.isCVQuaHan();
      this.checkIsHcNotification =
        this.isHCLTNotification() ||
        this.isHCDXNotification() ||
        this.isHCLTNotification;
      if (this.isVbNotificationV2()) {
        if (
          this.notificationDetail.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH
        ) {
          this.docCode = info.vbIncomingDoc.docCode;
          this.docDate = info.vbIncomingDoc.docDate;
        } else {
          this.docCode = info.object.docCode;
          this.docDate = info.object.docDate;
        }
      }
      if (this.isVbNotificationV1()) {
        this.docCode = info.data.docCode;
        this.docDate = info.data.docDate;
      }
    },

    isLetter() {
      let info = JSON.parse(this.notificationDetail.dataJson);
      return (
        this.LETTERS.indexOf(this.notificationDetail.messageType) !== -1 ||
        this.LETTERS.indexOf(info.emailCode) !== -1
      );
    },

    isCVNotification() {
      return (
        this.CV_MESSAGE_TYPES.indexOf(this.notificationDetail.messageType) !==
        -1
      );
    },

    isVbNotificationV2() {
      return (
        this.VB_MESSAGE_TYPE_V2.indexOf(this.notificationDetail.messageType) !==
        -1
      );
    },

    isDiscuss() {
      return (
        this.DISCUSS_TYPE.indexOf(this.notificationDetail.messageType) !== -1
      );
    },

    isDocument() {
      return (
        this.DOCUMENT_TYPE.indexOf(this.notificationDetail.messageType) !== -1
      );
    },

    isVbNotificationV1() {
      return (
        this.VB_MESSAGE_TYPE_V1.indexOf(this.notificationDetail.messageType) !==
        -1
      );
    },

    isHCPHNotification() {
      return (
        this.HC_MESSAGE_TYPES.PHONG_HOP.indexOf(
          this.notificationDetail.messageType
        ) !== -1
      );
    },

    isHCDXNotification() {
      return (
        this.HC_MESSAGE_TYPES.DIEU_XE.indexOf(
          this.notificationDetail.messageType
        ) !== -1
      );
    },

    isHCLTNotification() {
      return (
        this.HC_MESSAGE_TYPES.LICH_TUAN.indexOf(
          this.notificationDetail.messageType
        ) !== -1
      );
    },

    isCVQuaHan() {
      return (
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CANHBAOQUAHAN ===
        this.notificationDetail.messageType
      );
    },

    buildNameQuote(info) {
      if (this.isCVNotification()) {
        return info.tkTask.taskTitle;
      } else if (this.isVbNotificationV2()) {
        if (
          this.notificationDetail.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH
        ) {
          return info.vbIncomingDoc.quote;
        }
        return info.object.quote;
      } else if (this.isVbNotificationV1()) {
        return info.data.quote;
      } else if (this.isHCPHNotification()) {
        return info.hcCasePhonghop.meetingTitle;
      } else if (this.isHCDXNotification()) {
        return info.hcCaseDieuXe.title;
      } else if (this.isHCLTNotification()) {
        return info.hcCaseCalendar.meetingTitle;
      } else if (this.isDiscuss()) {
        return info.discuss.topic;
      } else if (this.isDocument()) {
        return info.document.documentName;
      } else if (
        this.notificationDetail.messageType ===
        constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CANHBAOQUAHAN
      ) {
        return info.tkTask.taskTitle;
      } else if (
        this.notificationDetail.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI ||
        this.notificationDetail.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI
      ) {
        return info.communication.communicationsName;
      } else if (
        this.notificationDetail.messageType ===
        constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNEWS
      ) {
        return info.news.title;
      } else if (this.isLetter(info)) {
        if (info.form.type === 1)
          return `xin nghỉ phép`;
        if (info.form.type === 2)
          return `xin vắng mặt`;
        if (info.form.type === 3)
          return `giải trình`;
        if (info.form.type === 4)
          return `tăng ca`;
        if (info.form.type === 5)
          return `công tác`;
      }
      return "";
    },

    buildActionLabel(info) {
      switch (this.notificationDetail.messageType) {
        // Tài liệu
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_APPROVE:
          return "Phê duyệt tài liệu";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_CREATE:
          return "Yêu cầu phê duyệt tài liệu";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DOCUMENT_REJECT:
          return "Từ chối tài liệu";
        // Tin tức
        case "addNews":
          return "Thêm bản tin mới";
        // Văn bản
        case "chuyenXuLy":
          return "Chuyển xử lý";
        case "chuyenTiep":
          return "Chuyển tiếp";
        case "thuHoi":
          return "Thu hồi";
        case "ketThuc":
          return "Ký duyệt";
        case "tuChoi":
          return "Từ chối";
        case "tuChoiBanHanh":
          return "Từ chối ban hành";
        case "banhanh":
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH:
          return "Ban hành";
        case "choBanHanh":
          return "Ký duyệt";
        case "CC":
          return "CC văn bản";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.THU_HOI_CC:
          return "Thu hồi văn bản";
        case "chuyenTiepLanhDao":
          return "Chuyển tiếp";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_COMMENT:
          return "Gửi bình luận";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.OUTGOING_KETTHUC:
          return "Phê duyệt";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_TUCHOI:
          return "Đã từ chối";
        case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
          return "Từ chối tiếp nhận";
        case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
          return "Từ chối";
        // Công việc
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET:
          return "Phê duyệt";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_GIAOVIEC:
          return "Giao";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_DANGKY:
          return "Đăng ký";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI:
          return "Từ chối đăng ký";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TAMDUNG:
          return "Tạm dừng";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HUY:
          return "Hủy";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CHANGE_DEADLINE:
          return "Gia hạn";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET_HOANTHANH:
          return "Đánh giá công việc";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI_HOANTHANH:
          return "Từ chối duyệt kết quả";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HOANTHANH:
          return "Cập nhật hoàn thành";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CAPNHAT_TIENDO:
          return "Cập nhật tiến độ";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TK_TASK.COMMENT:
          return "Bình luận";
        // Thông báo
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI:
          return "Thông báo";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI:
          return "Hủy thông báo";
        // Thảo luận
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT:
          return "Nhắc đến bạn trong";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS:
          return "Phê duyệt";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS:
          return "Từ chối";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS:
          return "Xóa";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS:
          return "Yêu cầu phê duyệt";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT:
          return "Báo cáo bình luận";
        // Hành chính
        // Phòng họp
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP:
          return "Đăng ký phòng họp";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP:
          return "Hủy phòng họp";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .CAP_NHAT_PHONG_HOP:
          return "Cập nhật phòng họp";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .PHE_DUYET_PHONG_HOP:
          return "Phê duyệt phòng họp";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .TU_CHOI_PHONG_HOP:
          return "Từ chối phòng họp";
        // Điều xe
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY:
          return "Đăng ký điều xe";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .HUY_YEU_CAU:
          return "Hủy điều xe";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT:
          return "Cập nhật điều xe";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .PHE_DUYET:
          return "Phê duyệt điều xe";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI:
          return "Từ chối điều xe";
        // Lịch tuần
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .DANG_KY:
          return "Đăng ký lịch tuần";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .HUY_YEU_CAU:
          return "Hủy lịch tuần";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .CAP_NHAT:
          return "Cập nhật lịch tuần";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .PHE_DUYET:
          return "Phê duyệt lịch tuần";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .TU_CHOI:
          return "Từ chối lịch tuần";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.YEU_CAU:
          return "Gửi";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.PHE_DUYET:
          return "Phê duyệt";
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.TU_CHOI:
          return "Từ chối";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/vb-notification-item.vue